module.exports = __webpack_public_path__ + "media/finney.c6fbef73.mp3";